var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"primary-button",attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.clicked}},[(_vm.isRunning)?_c('Spinner'):_vm._e(),_vm._t("default",null,{"isRunning":_vm.isRunning})],2)}
var staticRenderFns = []

export { render, staticRenderFns }